import { axiosInstance } from '@src/services/common';

export async function postDropoffQuery(payload: DropoffPayload) {
  const response = await axiosInstance.post<{ dropoff_analysis: Array<DropoffReason> }>(
    '/gm/dropoff',
    payload,
  );

  return response.data?.dropoff_analysis ?? [];
}

export async function postDropoffPatternsQuery(payload: DropoffPayload) {
  const response = await axiosInstance.post<{ patterns: Array<Array<DropoffPattern>> }>(
    '/gm/dropoff/patterns',
    payload,
  );

  return response.data?.patterns ?? [];
}
